// import * as React from 'react';
import { useEffect, useState } from "react";

import Head from "next/head";
// import Link from 'next/link';
import Image from "next/image";
import { useRouter } from "next/router";
import Slider from "react-slick";
//custom components
import Header from "components/sections/headerSecondary";
import Texture from "components/sections/texture";
import TexturePopup from "components/sections/texture-popup";
import Form from "components/sections/form";

import Navbar from "components/navbar";
import Footer from "components/footerCoating";
import FeaturesSlide from "components/sections/featuresBenefitsCarousel";
import ProductsSlide from "components/sections/productCarousel";
import IndustrialSectorsSlide from "components/sections/IndustrialSectorCarousel";

import CheckBoxIcon from "/assets/Pictures/jotafloor/icon-check-square.svg";

//header
import videoPoster from "/assets/Pictures/industrial-coating/poster.png";
import videoPosterMobile from "/assets/Pictures/industrial-coating/poster.png";
//import videobg from '/assets/Pictures/jotafloor/header-video.mp4';

import title from "/assets/Pictures/industrial-coating/jotafloor-logo-white.png";
//section images
import imgSection01 from "/assets/Pictures/industrial-coating/section-1-img.jpg";

//texture images
import prod1 from "/assets/Pictures/industrial-coating/prod-1.jpg";
import prod2 from "/assets/Pictures/industrial-coating/prod-2.jpg";
import prod3 from "/assets/Pictures/industrial-coating/prod-3.jpg";
import prod4 from "/assets/Pictures/industrial-coating/prod-4.jpg";
import prod5 from "/assets/Pictures/industrial-coating/prod-5.jpg";
import prod6 from "/assets/Pictures/industrial-coating/prod-6.jpg";
import prod7 from "/assets/Pictures/industrial-coating/prod-7.jpg";
import prod8 from "/assets/Pictures/industrial-coating/prod-8.jpg";

import IndustrialSectorImg1 from "/assets/Pictures/industrial-coating/ind-1.jpg";
import IndustrialSectorImg2 from "/assets/Pictures/industrial-coating/ind-2.jpg";
import IndustrialSectorImg3 from "/assets/Pictures/industrial-coating/ind-3.jpg";
import IndustrialSectorImg4 from "/assets/Pictures/industrial-coating/ind-4.jpg";
import IndustrialSectorImg5 from "/assets/Pictures/industrial-coating/ind-5.jpg";
import IndustrialSectorImg6 from "/assets/Pictures/industrial-coating/ind-6.jpg";
import IndustrialSectorImg7 from "/assets/Pictures/industrial-coating/ind-7.jpg";

import coatingEducational from "/assets/Pictures/industrial-coating/texture-coating-poster.png";

//slider images
import durable from "/assets/Pictures/industrial-coating/durable@2x.png";
import Mechanical from "/assets/Pictures/jotafloor/Superior-Mechanical@2x.png";
import WaterResistance from "/assets/Pictures/jotafloor/Waterproof@2x.png";
import impactResistance from "/assets/Pictures/industrial-coating/impact-resistance@2x.png";
import ChemicalResistance from "/assets/Pictures/jotafloor/Chemical_Resistant@2x.png";
import seamless from "/assets/Pictures/industrial-coating/seamless@2x.png";

//common

import styles from "styles/microsite.module.scss";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import { isMobileOnly } from "react-device-detect";
import ReactPlayer from "react-player/youtube";
import { motion } from "framer-motion";

import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "react-i18next";
export async function getServerSideProps({ locale, query }) {
  return {
    props: {
      query,
      ...(await serverSideTranslations(locale, [
        "wonderwalllux",
        "common",
        "shine",
        "ultimatt",
        "jotafloor",
        "coating"
      ])),
    },
  };
}

function JotaFloorPage({ props }) {
  const { t } = useTranslation();

  const { locale } = useRouter();

  const isMobile = isMobileOnly;

  const [gutter, setgutter] = useState();
  const [spacing, setspacing] = useState();

  //features slider
  const settings = {
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    //autoplay: true,
    //autoplaySpeed: 2000,
    // prevArrow: <SamplePrevArrow/>,
    //     nextArrow:  <SampleNextArrow/>,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  //resize callback - start
  const useWidth = () => {
    if (process.browser) {
      const [width, setWidth] = useState(window.innerWidth);
      const handleResize = () => setWidth(window.innerWidth);
      useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, [width]);
      return width;
    }
    return 0;
  };
  const windowWidth = useWidth();
  useEffect(() => {
    if (windowWidth < 480) {
      setgutter(true);
      setspacing(0);
    } else {
      setgutter(false);
      setspacing(9);
    }
  }, [windowWidth]);
  //resize callback - end

  //image blur start
  const shimmer = (w, h) => `
  <svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <linearGradient id="g">
        <stop stop-color="#333" offset="20%" />
        <stop stop-color="#222" offset="50%" />
        <stop stop-color="#333" offset="70%" />
      </linearGradient>
    </defs>
    <rect width="${w}" height="${h}" fill="#333" />
    <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
    <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"  />
  </svg>`;
  const toBase64 = (str) =>
    typeof window === "undefined"
      ? Buffer.from(str).toString("base64")
      : window.btoa(str);
  //image blur end

  return (
    <>
      <Head>
        <title>
          {t("common:jotafloor")} | {t("common:site_title")}
        </title>
        <meta name="description" content={t("coating:section_desc")} />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Navbar />

      <main className={`${styles.main} main_home`}>
        {/* <Header collection="jotafloor" title={title} titleW="562" titleH="188" poster={videoPoster} bgvideo={videobg} youtube="https://www.youtube.com/watch?v=XpeRQHbZ14E"/> */}
        <Header
          collection="coating"
          titleText={t("coating:page_title")}
          subTitleText={t("coating:page_sub_title")}
          title={title}
          titleW="560"
          titleH="158"
          posterdesktop={videoPoster.src}
          postermobile={videoPosterMobile.src}
          youtube="https://youtu.be/ftk2K-sjkoE"
          isimage="0"
        />

        <div id="the-lifeshine-collection" className={styles.section}>
          <header className={styles.header}>
            <Container
              maxWidth="lg"
              className={`${styles.container_header} container_header`}
            >
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={0}
                className={`${styles.grid_container} grid_container`}
              >
                <Grid
                  item
                  xs={10}
                  md={5}
                  className={`${styles.grid_item} grid_item`}
                >
                  <h1 className={styles.header_title}>
                    {t("coating:section_desc")}
                  </h1>
                  {/* <p className={styles.header_desc}>{t('coating:section_desc')}</p> */}
                </Grid>
              </Grid>
            </Container>
          </header>

          <Container
            disableGutters={gutter}
            maxWidth="lg"
            component="article"
            className={`${styles.article_img} article_img`}
          >
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="stretch"
              spacing={0}
              className={`${styles.grid_container} grid_container`}
            >
              <Grid
                item
                xs={12}
                md={8}
                className={`${styles.grid_img} grid_img`}
              >
                <Image
                  placeholder="blur"
                  src={imgSection01}
                  width="862"
                  height="559"
                  layout="responsive"
                  className="img_fluid"
                  alt={
                    t("coating:article_01_title_a") +
                    t("coating:article_01_title_b")
                  }
                  priority
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={4}
                className={`${styles.grid_context} grid_context`}
              >
                <div className={`${styles.context_wr} context_wr`}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    component="h2"
                    className={`${styles.title} title`}
                  >
                    <span className={`${styles.text_1} text_1`}>
                      {t("coating:article_01_title_a")}
                    </span>
                    <span className={`${styles.text_2} text_2`}>
                      {t("coating:article_01_title_b")}
                    </span>
                  </Typography>
                  <Typography
                    variant="body1"
                    gutterBottom
                    paragraph={true}
                    component="div"
                    sx={{ mb: 0 }}
                    dangerouslySetInnerHTML={{
                      __html: t("coating:article_01_desc"),
                    }}
                  ></Typography>
                </div>
              </Grid>
            </Grid>
          </Container>
          <Container
            disableGutters={gutter}
            id="collection-features-and-benefits"
            maxWidth="xl"
            component="article"
            className={`${styles.article_ind_sectors} article_ind_sectors`}
          >
            <Grid
              item
              xs={12}
              md={12}
              className={`${styles.grid_container} grid_container`}
              spacing={spacing}
            >
              <div className={`${styles.context_wr} context_wr`}>
                <div className={`${styles.context_wr} context_wr`}>
                  <Slider {...settings}>
                    <IndustrialSectorsSlide
                      className="product-item"
                      slideIcon={IndustrialSectorImg1.src}
                      slideTitle={t("coating:ind_1_sector_title")}
                    />
                    <IndustrialSectorsSlide
                      className="product-item"
                      slideIcon={IndustrialSectorImg2.src}
                      slideTitle={t("coating:ind_2_sector_title")}
                    />
                    <IndustrialSectorsSlide
                      className="product-item"
                      slideIcon={IndustrialSectorImg3.src}
                      slideTitle={t("coating:ind_3_sector_title")}
                    />
                    <IndustrialSectorsSlide
                      className="product-item"
                      slideIcon={IndustrialSectorImg4.src}
                      slideTitle={t("coating:ind_4_sector_title")}
                    />
                    <IndustrialSectorsSlide
                      className="product-item"
                      slideIcon={IndustrialSectorImg5.src}
                      slideTitle={t("coating:ind_5_sector_title")}
                    />
                    <IndustrialSectorsSlide
                      className="product-item"
                      slideIcon={IndustrialSectorImg6.src}
                      slideTitle={t("coating:ind_6_sector_title")}
                    />
                    <IndustrialSectorsSlide
                      className="product-item"
                      slideIcon={IndustrialSectorImg7.src}
                      slideTitle={t("coating:ind_7_sector_title")}
                    />
                  </Slider>
                </div>
              </div>
            </Grid>
          </Container>
        </div>

        <Container
          disableGutters={gutter}
          maxWidth="lg"
          component="article"
          className={`${styles.article_features_slider} article_features_slider`}
        >
          <Grid
            item
            xs={12}
            md={12}
            className={`${styles.grid_context} grid_context`}
          >
            <div className={`${styles.context_wr} context_wr`}>
              <Typography
                variant="subtitle1"
                gutterBottom
                component="h2"
                className={`${styles.title} title`}
              >
                <h4 className={styles.header_title}>
                  {t("common:features_and_benefits")}
                </h4>
              </Typography>
              <div>
                <Slider {...settings}>
                  <FeaturesSlide
                    className="feature-item"
                    slideIcon={durable.src}
                    slideText={t("coating:feature1")}
                  />
                  <FeaturesSlide
                    className="feature-item"
                    slideIcon={Mechanical.src}
                    slideText={t("coating:feature2")}
                  />
                  <FeaturesSlide
                    className="feature-item"
                    slideIcon={WaterResistance.src}
                    slideText={t("coating:feature3")}
                  />
                  <FeaturesSlide
                    className="feature-item"
                    slideIcon={impactResistance.src}
                    slideText={t("coating:feature4")}
                  />
                  <FeaturesSlide
                    className="feature-item"
                    slideIcon={ChemicalResistance.src}
                    slideText={t("coating:feature5")}
                  />
                  <FeaturesSlide
                    className="feature-item"
                    slideIcon={seamless.src}
                    slideText={t("coating:feature6")}
                  />
                </Slider>
              </div>
            </div>
          </Grid>
        </Container>

        <Container
          disableGutters={gutter}
          id="collection-features-and-benefits"
          maxWidth="xl"
          component="article"
          className={`${styles.article_discover_products} article_discover_products`}
        >
          <header className={styles.header}>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={0}
              className={`${styles.grid_container} grid_container`}
            >
              <Grid
                item
                xs={12}
                md={12}
                className={`${styles.grid_item} grid_item`}
              >
                <h2 className={styles.header_title}>
                  {t("coating:section_title")}
                </h2>
              </Grid>
            </Grid>
          </header>
          <Grid
            item
            xs={12}
            md={12}
            className={`${styles.grid_container} grid_container`}
            spacing={spacing}
          >
            <div className={`${styles.context_wr} context_wr`}>
              <Slider {...settings}>
                <ProductsSlide
                  className="product-item"
                  slideIcon={prod1.src}
                  slideTitle={t("coating:prod_1_feature_benefits_title")}
                  slideDesc={t("coating:prod_1_feature_benefits_desc")}
                  slideFeatures={Object.entries(t("coating:prod_1_feature_benefits_list", {
                    returnObjects: true,
                  })).map((item) => (
                    <li key={item}>
                      <CheckBoxIcon fontSize="inherit" />
                      <ListItemText primary={item} />
                    </li>
                  ))}
                />
                <ProductsSlide
                  className="product-item"
                  slideIcon={prod2.src}
                  slideTitle={t("coating:prod_2_feature_benefits_title")}
                  slideDesc={t("coating:prod_2_feature_benefits_desc")}
                  slideFeatures={Object.entries(t("coating:prod_2_feature_benefits_list", {
                    returnObjects: true,
                  })).map((item) => (
                    <li key={item}>
                      <CheckBoxIcon fontSize="inherit" />
                      <ListItemText primary={item} />
                    </li>
                  ))}
                />
                <ProductsSlide
                  className="product-item"
                  slideIcon={prod3.src}
                  slideTitle={t("coating:prod_3_feature_benefits_title")}
                  slideDesc={t("coating:prod_3_feature_benefits_desc")}
                  slideFeatures={Object.entries(t("coating:prod_3_feature_benefits_list", {
                    returnObjects: true,
                  })).map((item) => (
                    <li key={item}>
                      <CheckBoxIcon fontSize="inherit" />
                      <ListItemText primary={item} />
                    </li>
                  ))}
                />
                <ProductsSlide
                  className="product-item"
                  slideIcon={prod4.src}
                  slideTitle={t("coating:prod_4_feature_benefits_title")}
                  slideDesc={t("coating:prod_4_feature_benefits_desc")}
                  slideFeatures={Object.entries(t("coating:prod_4_feature_benefits_list", {
                    returnObjects: true,
                  })).map((item) => (
                    <li key={item}>
                      <CheckBoxIcon fontSize="inherit" />
                      <ListItemText primary={item} />
                    </li>
                  ))}
                />
                <ProductsSlide
                  className="product-item"
                  slideIcon={prod5.src}
                  slideTitle={t("coating:prod_5_feature_benefits_title")}
                  slideDesc={t("coating:prod_5_feature_benefits_desc")}
                  slideFeatures={Object.entries(t("coating:prod_5_feature_benefits_list", {
                    returnObjects: true,
                  })).map((item) => (
                    <li key={item}>
                      <CheckBoxIcon fontSize="inherit" />
                      <ListItemText primary={item} />
                    </li>
                  ))}
                />
                <ProductsSlide
                  className="product-item"
                  slideIcon={prod6.src}
                  slideTitle={t("coating:prod_6_feature_benefits_title")}
                  slideDesc={t("coating:prod_6_feature_benefits_desc")}
                  slideFeatures={Object.entries(t("coating:prod_6_feature_benefits_list", {
                    returnObjects: true,
                  })).map((item) => (
                    <li key={item}>
                      <CheckBoxIcon fontSize="inherit" />
                      <ListItemText primary={item} />
                    </li>
                  ))}
                />
                <ProductsSlide
                  className="product-item"
                  slideIcon={prod7.src}
                  slideTitle={t("coating:prod_7_feature_benefits_title")}
                  slideDesc={t("coating:prod_7_feature_benefits_desc")}
                  slideFeatures={Object.entries(t("coating:prod_7_feature_benefits_list", {
                    returnObjects: true,
                  })).map((item) => (
                    <li key={item}>
                      <CheckBoxIcon fontSize="inherit" />
                      <ListItemText primary={item} />
                    </li>
                  ))}
                />
                <ProductsSlide
                  className="product-item il"
                  slideIcon={prod8.src}
                  slideTitle={t("coating:prod_8_feature_benefits_title")}
                  slideDesc={t("coating:prod_8_feature_benefits_desc")}
                  slideFeatures={Object.entries(t("coating:prod_8_feature_benefits_list", {
                    returnObjects: true,
                  })).map((item) => (
                    <li key={item}>
                      <CheckBoxIcon fontSize="inherit" />
                      <ListItemText primary={item} />
                    </li>
                  ))}
                />
              </Slider>
              <div></div>
            </div>
          </Grid>
        </Container>

        <Container
          maxWidth={false}
          disableGutters={true}
          className={`${styles.article_educational_video} article_educational_video`}
        >
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            spacing={0}
            component="figure"
            className="panel"
            sx={{
              m: 0,
            }}
          >
            <Grid
              item
              xs={12}
              md={12}
              className={`${styles.discover_video} discover_video`}
            >
              <Texture
                caption={t("coating:ripple")}
                texture="coating/texture-coating"
                imgtexture={coatingEducational}
              />
            </Grid>
          </Grid>
        </Container>

        <Container
          id="informations"
          maxWidth="lg"
          component="section"
          className={`${styles.section_informations} section_informations jotafloor_informations`}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            spacing={2}
            className={`${styles.grid_container} grid_container`}
          >
            <Grid
              item
              xs={12}
              md={5}
              className={`${styles.grid_form} grid_form`}
            >
              <Typography
                variant="subtitle1"
                gutterBottom
                component="h2"
                className={`${styles.title} title`}
              >
                {t("common:form_title")}
              </Typography>
              <Form collection="New Jotafloor Page Message" />
            </Grid>

            <Grid
              item
              xs={12}
              md={6}
              className={`${styles.grid_datasheets} grid_datasheets`}
            >
              <Typography
                variant="subtitle1"
                gutterBottom
                component="h4"
                className={`${styles.title} title`}
              >
                {t("common:technical_datasheets")}
              </Typography>

              <List className={`${styles.list_download} list_download`}>
                {Object.values(t("coating:TDS_download_files", { returnObjects: true })).map(
                  ({ label, file }) => (
                    <ListItem
                      className={`${styles.list_item} list_item`}
                      key={label}
                    >
                      <ListItemText
                        className={`${styles.list_label} list_label`}
                        primary={label}
                      />
                      <a
                        className={`${styles.list_link} list_link`}
                        href={file}
                        aria-label={t("common:view") + " " + label}
                        title={t("common:view") + " " + label}
                        download
                        target="_blank"
                      >
                        <ListItemText
                          className={`${styles.list_download} list_download`}
                          primary={t("common:view")}
                        />
                      </a>
                    </ListItem>
                  )
                )}
              </List>
              <br />
              <Typography
                variant="subtitle1"
                gutterBottom
                component="h4"
                spacing={3}
                className={`${styles.title} title`}
              >
                {t("common:other_datasheets")}
              </Typography>

              <List className={`${styles.list_download} list_download`}>
                {Object.values(t("coating:other_download_files", { returnObjects: true })).map(
                  ({ label, file }) => (
                    <ListItem
                      className={`${styles.list_item} list_item`}
                      key={label}
                    >
                      <ListItemText
                        className={`${styles.list_label} list_label`}
                        primary={label}
                      />
                      <a
                        className={`${styles.list_link} list_link`}
                        href={"/download/coating/" + file}
                        aria-label={t("common:download") + " " + label}
                        title={t("common:download") + " " + label}
                        target="_blank"
                        download
                      >
                        <ListItemText
                          className={`${styles.list_download} list_download`}
                          primary={t("common:download")}
                        />
                      </a>
                    </ListItem>
                  )
                )}
              </List>
            </Grid>
          </Grid>
        </Container>
      </main>

      <Footer />
    </>
  );
}
export default JotaFloorPage;